import { useQuery } from 'react-query';
import request from '../../../helpers/request';
import { getQueryKeys } from './queryKeys';

const getAccountTypes = async () => {
  return await request.get(
    `/HousingStock/account_types`,
    {},
    'При загрузке типов лицевых счетов произошла ошибка',
    []
  );
};

const useAccountTypes = (options = {}) =>
  useQuery(getQueryKeys.accountTypes(), () => getAccountTypes(), {
    placeholderData: [],
    ...options,
  });

export default useAccountTypes;
